import { useMatch } from "react-router-dom";

import { BOT_ROUTE, PARTY_MARKET_SECTION_PATH } from "@/app/constants/routes";
import { LayerType } from "@/app/routing/types";
import { MainRoutes, PartyRoutes, getPartySectionLink } from "@/shared/routing";

const useGetPartyDefaultPath = () => {
	const match = useMatch(BOT_ROUTE);

	const partyUUID = match?.params.partyUUID;

	let partyURL = "";

	if (partyUUID) partyURL = getPartySectionLink({ partyUUID, partySection: PartyRoutes.Bots });

	return partyURL;
};

export const useGetMarketDefaultPath = () => {
	const match = useMatch(PARTY_MARKET_SECTION_PATH);

	const partyUUID = match?.params.partyUUID;

	let marketsURL = "";

	if (partyUUID) marketsURL = getPartySectionLink({ partyUUID, partySection: PartyRoutes.Markets });

	return marketsURL;
};

const MOVE_LAYER_MAP: Record<LayerType, (() => string) | null> = {
	main: null,
	party: () => MainRoutes.AllBots,
	market: useGetMarketDefaultPath,
	"cex-bot": useGetPartyDefaultPath,
	"dex-bot": useGetPartyDefaultPath,
	"dex-v2-bot": useGetPartyDefaultPath,
	"dex-ne-bot": useGetPartyDefaultPath,
};

export const useMoveLayer = (layer: LayerType) => {
	const toPath = MOVE_LAYER_MAP[layer]?.();

	if (toPath) return toPath;

	return null;
};
